import { render, staticRenderFns } from "./letter-template.vue?vue&type=template&id=df6fe058"
import script from "./letter-template.vue?vue&type=script&lang=ts"
export * from "./letter-template.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports